export const login_background = require("./login_background.png");
export const login_background1 = require("./login_background1.png");

export const Login_title = require("./Login.png");
export const Dashboard_de = require("./dashboard1.png");
export const Dashboard_active = require("./dashboard.png");
export const Roles_de = require("./HO1.png");
export const Roles_active = require("./HO.png");
export const Regional_de = require("./roles_de.png");
export const Regional_active = require("./roles.png");
export const back_icon = require("./back_icon.png");
export const alert = require("./alert.png");
export const blue = require("./1.png");
export const green = require("./2.png");
export const orange = require("./3.png");
export const red = require("./4.png");
export const pink = require("./5.png");
export const person = require("./person.png");

export const search = require("./search.png");
export const edit = require("./edit.png");
export const right = require("./right.png");
export const left = require("./left.png");
export const toggle_on = require("./toggle_on.png");
export const toggle_off = require("./toggle_off.png");
export const view = require("./view.png");
export const service_active = require("./service_ac.png");
export const service_deactive = require("./service_de.png");
export const download = require("./download.png");
export const okiee = require("./Group.png");
export const image_proof = require("./image_proof.png");

export const calender = require("./Vector1.png");
export const blue_star = require("./blue-star.png");
export const unblue_star = require("./unblue-star.png");
export const vedio = require("./SampleVideo_1280x720_1mb.mp4");
